import * as Yup from 'yup';

export const initialValues = {
    styleAndTonality: [
        { title: 'Cercano pero Formal', description: '' },
        { title: 'Técnicas de Explicación', description: '' },
        { title: 'Estructura de Respuesta', description: '' },
        { title: 'Directo', description: '' },
        { title: 'Paso a Paso', description: '' },
        { title: 'Confirmación Dinámica', description: '' },
    ],
};

export const validationSchema = Yup.object().shape({
    styleAndTonality: Yup.array().of(
        Yup.object().shape({
            title: Yup.string().required('Requerido'),
            description: Yup.string().required('Requerido'),
        })
    ),
});
